// Font Awesome 5 icons.
import {
  faAngleDown,
  faAngleRight,
  faAngleUp,
  faArchive,
  faArrowCircleLeft,
  faArrowLeft,
  faArrowRight,
  faArrowToBottom,
  faArrowToTop,
  faArrowsH,
  faArrowsV,
  faBadgeCheck,
  faBan,
  faBarcode,
  faBars,
  faBatteryFull,
  faBellOn,
  faBellSlash,
  faBold,
  faBrowser,
  faCalendar,
  faCalendarAlt,
  faCalendarCheck,
  faCalendarDay,
  faCalendarEdit,
  faCalendarPlus,
  faCalendarStar,
  faCalendarTimes,
  faCalendarWeek,
  faCaretDown,
  faCaretLeft,
  faCaretRight,
  faCaretUp,
  faChartBar,
  faChartLine,
  faCheck,
  faCheckCircle,
  faChevronDoubleDown,
  faCircle,
  faCircleNotch,
  faClipboard,
  faClipboardCheck,
  faClipboardList,
  faClock,
  faClone,
  faCloudDownload,
  faCloudUpload,
  faCode,
  faCodeBranch,
  faCog,
  faCogs,
  faColumns,
  faCompressAlt,
  faConciergeBell,
  faCopy,
  faCreditCard,
  faCubes,
  faDownload,
  faEdit,
  faEnvelope,
  faEnvelopeOpen,
  faEnvelopeOpenText,
  faEnvelopeSquare,
  faEraser,
  faExchange,
  faExclamationCircle,
  faExclamationSquare,
  faExclamationTriangle,
  faExpandAlt,
  faExternalLink,
  faEye,
  faFile,
  faFileAlt,
  faFileChartLine,
  faFileEdit,
  faFileImport,
  faFileInvoiceDollar,
  faFilter,
  faFlagCheckered,
  faFlask,
  faFolder,
  faFont,
  faFrown,
  faGlobe,
  faGraduationCap,
  faHandsUsd,
  faHashtag,
  faHeading,
  faHeartbeat,
  faHighlighter,
  faHistory,
  faHome,
  faHorizontalRule,
  faHourglass,
  faHourglassEnd,
  faHourglassHalf,
  faIdBadge,
  faImage,
  faInfoCircle,
  faInventory,
  faItalic,
  faKeyboard,
  faLayerPlus,
  faLink,
  faList,
  faListAlt,
  faListOl,
  faListUl,
  faLock,
  faLockOpen,
  faLongArrowAltUp,
  faMapMarkedAlt,
  faMapMarkerAlt,
  faMegaphone,
  faMinus,
  faMinusCircle,
  faMinusSquare,
  faMoneyBill,
  faMoneyCheck,
  faMoneyCheckEditAlt,
  faMoon,
  faPaintBrush,
  faPalette,
  faPaste,
  faPen,
  faPenFancy,
  faPencil,
  faPlay,
  faPlug,
  faPlus,
  faPlusCircle,
  faPlusSquare,
  faPoll,
  faPrint,
  faQrcode,
  faQuestion,
  faQuestionCircle,
  faQuoteLeft,
  faReply,
  faRss,
  faSave,
  faScanner,
  faSearch,
  faSearchDollar,
  faSensorOn,
  faShieldCheck,
  faSignInAlt,
  faSignOutAlt,
  faSitemap,
  faSlidersH,
  faSort,
  faSortDown,
  faSortUp,
  faStar,
  faStrikethrough,
  faSun,
  faSync,
  faTable,
  faTablet,
  faTachometerAlt,
  faTag,
  faTags,
  faTasks,
  faThumbsUp,
  faThumbtack,
  faTimes,
  faTimesCircle,
  faTimesOctagon,
  faTimesSquare,
  faTools,
  faTrash,
  faTrashRestore,
  faUniversity,
  faUpload,
  faUsbDrive,
  faUser,
  faUserCheck,
  faUserClock,
  faUserFriends,
  faUserGraduate,
  faUserLock,
  faUserPlus,
  faUserSlash,
  faUsers,
  faUsersClass,
  faVial,
  faVolumeSlash,
  faWallet,
  faWandMagic,
  faWatch,
  faWrench,
} from '@fortawesome/pro-regular-svg-icons';
import {
  faBadgeCheck as faBadgeCheckSolid,
  faBan as faBanSolid,
  faBellOn as faBellOnSolid,
  faBellSlash as faBellSlashSolid,
  faBolt as faBoltSolid,
  faBook as faBookSolid,
  faBug as faBugSolid,
  faBullhorn as faBullhornSolid,
  faCalendar as faCalendarSolid,
  faCaretDown as faCaretDownSolid,
  faCaretLeft as faCaretLeftSolid,
  faCaretRight as faCaretRightSolid,
  faCaretUp as faCaretUpSolid,
  faCheck as faCheckSolid,
  faCheckCircle as faCheckCircleSolid,
  faChevronDoubleDown as faChevronDoubleDownSolid,
  faCircle as faCircleSolid,
  faClipboard as faClipboardSolid,
  faCloudUpload as faCloudUploadSolid,
  faCodeBranch as faCodeBranchSolid,
  faCog as faCogSolid,
  faCommentsAlt as faCommentsAltSolid,
  faCopy as faCopySolid,
  faEnvelope as faEnvelopeSolid,
  faExclamationTriangle as faExclamationTriangleSolid,
  faFilePdf as faFilePdfSolid,
  faFilmAlt as faFilmSolid,
  faForward as faForwardSolid,
  faGavel as faGavelSolid,
  faGlobe as faGlobeSolid,
  faGripVertical as faGripVerticalSolid,
  faHandshakeAlt as faHandshakeAltSolid,
  faInfoCircle as faInfoCircleSolid,
  faKey as faKeySolid,
  faLock as faLockSolid,
  faLockOpen as faLockOpenSolid,
  faMoon as faMoonSolid,
  faPaperPlane as faPaperPlaneSolid,
  faPause as faPauseSolid,
  faPencil as faPencilSolid,
  faPhone as faPhoneSolid,
  faPlay as faPlaySolid,
  faPlusCircle as faPlusCircleSolid,
  faQuestion as faQuestionSolid,
  faRabbitFast as faRabbitFastSolid,
  faRedoAlt as faRedoAltSolid,
  faRepeat as faRepeatSolid,
  faRobot as faRobotSolid,
  faRocketLaunch as faRocketLaunchSolid,
  faSearch as faSearchSolid,
  faShareAlt as faShareAltSolid,
  faShieldAlt as faShieldAltSolid,
  faShieldCheck as faShieldCheckSolid,
  faSignalAlt as faSignalAlt4Solid,
  faSignalAlt1 as faSignalAlt1Solid,
  faSignalAlt2 as faSignalAlt2Solid,
  faSignalAlt3 as faSignalAlt3Solid,
  faSignalAltSlash as faSignalAltSlashSolid,
  faSlidersH as faSlidersHSolid,
  faSparkles as faSparklesSolid,
  faSpinner as faSpinnerSolid,
  faStar as faStarSolid,
  faStars as faStarsSolid,
  faSun as faSunSolid,
  faSync as faSyncSolid,
  faSyncAlt as faSyncAltSolid,
  faTag as faTagSolid,
  faTags as faTagsSolid,
  faTh as faThSolid,
  faThumbtack as faThumbtackSolid,
  faTimes as faTimesSolid,
  faTimesCircle as faTimesCircleSolid,
  faToggleOn as faToggleOnSolid,
  faUndoAlt as faUndoAltSolid,
  faUniversity as faUniversitySolid,
  faUser as faUserSolid,
  faUserCircle as faUserCircleSolid,
  faUserPlus as faUserPlusSolid,
  faUsers as faUsersSolid,
  faWrench as faWrenchSolid,
} from '@fortawesome/pro-solid-svg-icons';

import {
  faCalendarDay as faCalendarDayDuo,
  faSignInAlt as faSignInAltDuo,
  faUserShield as faUserShieldDuo,
} from '@fortawesome/pro-duotone-svg-icons';

import {
  faCcAmex,
  faGoogle,
  faCcMastercard,
  faCcVisa,
  faLinux,
  faTwitter,
  faWindows,
} from '@fortawesome/free-brands-svg-icons';

// faIcons is the icon map for Font Awesome 5 icons.
export const faIcons = {
  faAngleDown,
  faAngleRight,
  faAngleUp,
  faArchive,
  faArrowCircleLeft,
  faArrowLeft,
  faArrowRight,
  faArrowToBottom,
  faArrowToTop,
  faArrowsH,
  faArrowsV,
  faBadgeCheck,
  faBadgeCheckSolid,
  faBan,
  faBanSolid,
  faBarcode,
  faBars,
  faBatteryFull,
  faBellOn,
  faBellOnSolid,
  faBellSlash,
  faBellSlashSolid,
  faBold,
  faBoltSolid,
  faBookSolid,
  faBrowser,
  faBugSolid,
  faBullhornSolid,
  faCalendar,
  faCalendarAlt,
  faCalendarCheck,
  faCalendarDay,
  faCalendarDayDuo,
  faCalendarEdit,
  faCalendarPlus,
  faCalendarSolid,
  faCalendarStar,
  faCalendarTimes,
  faCalendarWeek,
  faCaretDown,
  faCaretDownSolid,
  faCaretLeft,
  faCaretLeftSolid,
  faCaretRight,
  faCaretRightSolid,
  faCaretUp,
  faCaretUpSolid,
  faCcAmex,
  faCcMastercard,
  faCcVisa,
  faChartBar,
  faChartLine,
  faCheck,
  faCheckCircle,
  faCheckCircleSolid,
  faCheckSolid,
  faChevronDoubleDown,
  faChevronDoubleDownSolid,
  faCircle,
  faCircleNotch,
  faCircleSolid,
  faClipboard,
  faClipboardCheck,
  faClipboardList,
  faClipboardSolid,
  faClock,
  faClone,
  faCloudDownload,
  faCloudUpload,
  faCloudUploadSolid,
  faCode,
  faCodeBranch,
  faCodeBranchSolid,
  faCog,
  faCogSolid,
  faCogs,
  faColumns,
  faCommentsAltSolid,
  faCompressAlt,
  faConciergeBell,
  faCopy,
  faCopySolid,
  faCreditCard,
  faCubes,
  faDownload,
  faEdit,
  faEnvelope,
  faEnvelopeOpen,
  faEnvelopeOpenText,
  faEnvelopeSolid,
  faEnvelopeSquare,
  faEraser,
  faExchange,
  faExclamationCircle,
  faExclamationSquare,
  faExclamationTriangle,
  faExclamationTriangleSolid,
  faExpandAlt,
  faExternalLink,
  faEye,
  faFile,
  faFileAlt,
  faFileChartLine,
  faFileEdit,
  faFileImport,
  faFileInvoiceDollar,
  faFilePdfSolid,
  faFilmSolid,
  faFilter,
  faFlagCheckered,
  faFlask,
  faFolder,
  faFont,
  faForwardSolid,
  faFrown,
  faGavelSolid,
  faGlobe,
  faGlobeSolid,
  faGoogle,
  faGraduationCap,
  faGripVerticalSolid,
  faHandsUsd,
  faHandshakeAltSolid,
  faHashtag,
  faHeading,
  faHeartbeat,
  faHighlighter,
  faHistory,
  faHome,
  faHorizontalRule,
  faHourglass,
  faHourglassEnd,
  faHourglassHalf,
  faIdBadge,
  faImage,
  faInfoCircle,
  faInfoCircleSolid,
  faInventory,
  faItalic,
  faKeySolid,
  faKeyboard,
  faLayerPlus,
  faLink,
  faLinux,
  faList,
  faListAlt,
  faListOl,
  faListUl,
  faLock,
  faLockOpen,
  faLockOpenSolid,
  faLockSolid,
  faLongArrowAltUp,
  faMapMarkedAlt,
  faMapMarkerAlt,
  faMegaphone,
  faMinus,
  faMinusCircle,
  faMinusSquare,
  faMoneyBill,
  faMoneyCheck,
  faMoneyCheckEditAlt,
  faMoon,
  faMoonSolid,
  faPaintBrush,
  faPalette,
  faPaperPlaneSolid,
  faPaste,
  faPauseSolid,
  faPen,
  faPenFancy,
  faPencil,
  faPencilSolid,
  faPhoneSolid,
  faPlay,
  faPlaySolid,
  faPlug,
  faPlus,
  faPlusCircle,
  faPlusCircleSolid,
  faPlusSquare,
  faPoll,
  faPrint,
  faQrcode,
  faQuestion,
  faQuestionCircle,
  faQuestionSolid,
  faQuoteLeft,
  faRabbitFastSolid,
  faRedoAltSolid,
  faRepeatSolid,
  faReply,
  faRobotSolid,
  faRocketLaunchSolid,
  faRss,
  faSave,
  faScanner,
  faSearch,
  faSearchDollar,
  faSearchSolid,
  faSensorOn,
  faShareAltSolid,
  faShieldAltSolid,
  faShieldCheck,
  faShieldCheckSolid,
  faSignInAlt,
  faSignInAltDuo,
  faSignOutAlt,
  faSignalAlt1Solid,
  faSignalAlt2Solid,
  faSignalAlt3Solid,
  faSignalAlt4Solid,
  faSignalAltSlashSolid,
  faSitemap,
  faSlidersH,
  faSlidersHSolid,
  faSort,
  faSortDown,
  faSortUp,
  faSparklesSolid,
  faSpinnerSolid,
  faStar,
  faStarSolid,
  faStarsSolid,
  faStrikethrough,
  faSun,
  faSunSolid,
  faSync,
  faSyncAltSolid,
  faSyncSolid,
  faTable,
  faTablet,
  faTachometerAlt,
  faTag,
  faTagSolid,
  faTags,
  faTagsSolid,
  faTasks,
  faThSolid,
  faThumbsUp,
  faThumbtack,
  faThumbtackSolid,
  faTimes,
  faTimesCircle,
  faTimesCircleSolid,
  faTimesOctagon,
  faTimesSolid,
  faTimesSquare,
  faToggleOnSolid,
  faTools,
  faTrash,
  faTrashRestore,
  faTwitter,
  faUndoAltSolid,
  faUniversity,
  faUniversitySolid,
  faUpload,
  faUsbDrive,
  faUser,
  faUserCheck,
  faUserCircleSolid,
  faUserClock,
  faUserFriends,
  faUserGraduate,
  faUserLock,
  faUserPlus,
  faUserPlusSolid,
  faUserShieldDuo,
  faUserSlash,
  faUserSolid,
  faUsers,
  faUsersClass,
  faUsersSolid,
  faVial,
  faVolumeSlash,
  faWallet,
  faWandMagic,
  faWatch,
  faWindows,
  faWrench,
  faWrenchSolid,
};

export const faSVG = (icon, extraClass, style, colorArg) => {
  let iconClass = extraClass;
  if (!iconClass) iconClass = '';
  let styleLine = '';
  if (style) styleLine = `style="${style}"`;
  let color = 'white';
  if (colorArg) color = colorArg;
  const svg = `
    <svg
      aria-hidden="true"
      data-fa-processed=""
      data-prefix="${icon.prefix}"
      data-icon="${icon.iconName}"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 ${icon.icon[0]} ${icon.icon[1]}"
      class="svg-inline--fa fa-${icon.iconName} ${iconClass}"
      ${styleLine}>
        <path fill="${color}" d="${icon.icon[4]}"></path>
    </svg>
  `;
  return svg;
};
